import React, { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  getEndOfMonth,
  getStartOfMonth,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import DragDrop from "../DragDrop/DragDrop";
import { showErrorMessage } from "../Shared/Toast";
function MaterialsTemplateType() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);

  const [packingSizeList, setPackingSizeList] = useState<any>([
    { PID: 81, Name: "Flatshare" },
    { PID: 82, Name: "Studio" },
    { PID: 83, Name: "1 Bed" },
    { PID: 84, Name: "2 Bed" },
    { PID: 85, Name: "3 Bed" },
    { PID: 86, Name: "4 Bed" },
    { PID: 87, Name: "5 Bed +" },
  ]);

  const [moversList, setMoversList] = useState<any>([
    { PID: 1, Name: "1 Packer" },
    { PID: 2, Name: "2 Packers" },
    { PID: 3, Name: "3 Packers" },
    { PID: 4, Name: "4 Packers" },
    { PID: 5, Name: "5 Packers" },
    { PID: 6, Name: "6 Packers" },
  ]);

  let LeftSideIds = [11, 12, 13, 14];

  const [materialsData, setMaterialsData] = useState<any>([]);
  const [materialsPriceTemplate, setMaterialsPriceTemplate] = useState<any>([]);

  const [addEditObject, setAddEditObject] = useState({
    mnvmaterialspricetemplatetypeid: 0,
    Name: "",
    Description: "",
    PackingSizeID: 0,
    MinMovers: 0,
    MaxMovers: 0,
    MinHours: "",
    MaxHours: "",
  });

  useEffect(() => {
    MNVMaterialsPriceTemplateTypeGetCompleteGridData();
  }, []);

  function MNVMaterialsPriceTemplateTypeGetCompleteGridData() {
    setIsAnimation(true);
    let object = {} as any;
    object.recordsperpage = 1000;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsPriceTemplateType/MNVMaterialsPriceTemplateTypeGetCompleteGridData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          setMaterialsData(l_oResponse[1]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    let IsOkay = true;
    let Message = "";
    if (addEditObject.Name == "") {
      IsOkay = false;
      Message = "Name required";
    } else if (addEditObject.PackingSizeID == 0) {
      IsOkay = false;
      Message = "Packing Size required";
    } else if (addEditObject.MinMovers == 0) {
      IsOkay = false;
      Message = "Min Movers required";
    } else if (addEditObject.MaxMovers == 0) {
      IsOkay = false;
      Message = "Max Movers required";
    }

    if (IsOkay) {
      MNVMoverBonusAndDeductionSaveCustom();
    } else {
      showErrorMessage(Message);
    }
  }

  function MNVMoverBonusAndDeductionSaveCustom() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmaterialspricetemplatetypeid =
      addEditObject.mnvmaterialspricetemplatetypeid;
    object.name = addEditObject.Name;
    object.description = addEditObject.Description;
    object.packingsizeid = addEditObject.PackingSizeID;
    object.minmovers = addEditObject.MinMovers;
    object.maxmovers = addEditObject.MaxMovers;
    object.minhours = addEditObject.MinHours;
    object.maxhours = addEditObject.MaxHours;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsPriceTemplateType/MNVMaterialsPriceTemplateTypeSave",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          setIsAddNew(0);
          MNVMaterialsPriceTemplateTypeGetCompleteGridData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVMaterialsPriceTemplateTypeDeleteRecord(
    mnvmaterialspricetemplatetypeid: any
  ) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmaterialspricetemplatetypeid = mnvmaterialspricetemplatetypeid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsPriceTemplateType/MNVMaterialsPriceTemplateTypeDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          MNVMaterialsPriceTemplateTypeGetCompleteGridData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVMaterialsPriceTemplateGetDataByTemplateType(PID: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.templatetypeid = PID;
    object.recordsperpage = 1000;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsPriceTemplate/MNVMaterialsPriceTemplateGetDataByTemplateType",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setMaterialsPriceTemplate(l_response);
          // console.log(l_response);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        MNVMaterialsPriceTemplateTypeDeleteRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  function getPackingSizeName(id: any) {
    let name = "";
    for (let index = 0; index < packingSizeList.length; index++) {
      if (packingSizeList[index].PID == id) {
        name = packingSizeList[index].Name;
        break;
      }
    }

    return name;
  }

  function getResourceText() {
    let text = "";
    if (addEditObject.MinMovers == addEditObject.MaxMovers) {
      text = addEditObject.MinMovers + " Packers";
    } else {
      text =
        addEditObject.MinMovers + "-" + addEditObject.MaxMovers + " Packers";
    }

    return text;
  }

  function updateValue(value: any, colName: any, index: number) {
    let array = [...materialsPriceTemplate];
    array[0][index][colName] = value;
    setMaterialsPriceTemplate(array);
  }

  function MNVMaterialsPriceTemplateSaveCustom(
    numberofunit: any,
    MNVMaterialsPriceTemplateID: any
  ) {
    setIsAnimation(true);
    let object = {} as any;
    object.numberofunit = numberofunit;
    object.mnvmaterialspricetemplateid = MNVMaterialsPriceTemplateID;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsPriceTemplate/MNVMaterialsPriceTemplateSaveCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          MNVMaterialsPriceTemplateGetDataByTemplateType(
            addEditObject.mnvmaterialspricetemplatetypeid
          );
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {isAddNew == 0 && (
        <>
          <>
            <div className="flex-d justify-btw mb-10">
              <div className="flex-da gap-10"></div>
              <div className="flex-daj flex-gap10">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => {
                      setAddEditObject({
                        mnvmaterialspricetemplatetypeid: 0,
                        Name: "",
                        Description: "",
                        PackingSizeID: 0,
                        MinMovers: 0,
                        MaxMovers: 0,
                        MinHours: "",
                        MaxHours: "",
                      });

                      setIsAddNew(1);
                    }}
                  >
                    Add New
                  </a>
                </div>
                <a
                  className="btn-primary flex-daj btn-grid"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel(
                      "tblemployeebandd",
                      "Materials Template Type"
                    )
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>

            <table className="reuse-table" id="tblemployeebandd">
              <thead>
                <tr>
                  <th>Name</th>
                  {/* <th>Description</th> */}
                  <th>Packing Size</th>
                  <th>Min Packers</th>
                  <th>Max Packers</th>
                  <th>Min Hours</th>
                  <th>Max Hours</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {materialsData &&
                  materialsData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      <tr key={index}>
                        <td>{item.Name}</td>
                        {/* <td>{item.Description}</td> */}
                        <td>{getPackingSizeName(item.PackingSizeID)}</td>
                        <td>{item.MinMovers}</td>
                        <td>{item.MaxMovers}</td>
                        <td>{item.MinHours}</td>
                        <td>{item.MaxHours}</td>
                        <td>
                          <div className="flex-daj gap-10">
                            <a
                              title="Manage Template"
                              onClick={() => {
                                setAddEditObject({
                                  mnvmaterialspricetemplatetypeid:
                                    item.MNVMaterialsPriceTemplateTypeID,
                                  Name: item.Name,
                                  Description: item.Description,
                                  PackingSizeID: item.PackingSizeID,
                                  MinMovers: item.MinMovers,
                                  MaxMovers: item.MaxMovers,
                                  MinHours: item.MinHours,
                                  MaxHours: item.MaxHours,
                                });
                                MNVMaterialsPriceTemplateGetDataByTemplateType(
                                  item.MNVMaterialsPriceTemplateTypeID
                                );
                                setIsAddNew(3);
                              }}
                            >
                              <img
                                src="images/m-manage.svg"
                                width="18px"
                                height="18px"
                                alt="Edit"
                              />
                            </a>
                            <a
                              onClick={() => {
                                setAddEditObject({
                                  mnvmaterialspricetemplatetypeid:
                                    item.MNVMaterialsPriceTemplateTypeID,
                                  Name: item.Name,
                                  Description: item.Description,
                                  PackingSizeID: item.PackingSizeID,
                                  MinMovers: item.MinMovers,
                                  MaxMovers: item.MaxMovers,
                                  MinHours: item.MinHours,
                                  MaxHours: item.MaxHours,
                                });
                                setIsAddNew(2);
                              }}
                            >
                              <img
                                src="images/edit.svg"
                                width="18px"
                                height="18px"
                                alt="Edit"
                              />
                            </a>
                            <a
                              onClick={() =>
                                globalState.setConfirmationModalObject({
                                  ShowPopup: true,
                                  Heading: "Alert",
                                  Message:
                                    "Are your sure, you want to delete this record?",
                                  ID: 1,
                                  SelectedID:
                                    item.MNVMaterialsPriceTemplateTypeID,
                                  OtherID: 0,
                                })
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="18px"
                                height="18px"
                                alt="Delete"
                              />
                            </a>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d">
                <input
                  className="input-field w-100"
                  placeholder="Name"
                  type="text"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <select
                  className="input-field w-100"
                  value={addEditObject.PackingSizeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PackingSizeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Packing Size</option>
                  {packingSizeList &&
                    packingSizeList.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d">
                <select
                  className="input-field w-100"
                  value={addEditObject.MinMovers}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MinMovers: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Min Movers</option>
                  {moversList &&
                    moversList.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d">
                <select
                  className="input-field w-100"
                  value={addEditObject.MaxMovers}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MaxMovers: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Max Movers</option>
                  {moversList &&
                    moversList.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d">
                <input
                  className="input-field w-100"
                  placeholder="Min Hours"
                  type="text"
                  value={addEditObject.MinHours}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MinHours: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <input
                  className="input-field w-100"
                  placeholder="Max Hours"
                  type="text"
                  value={addEditObject.MaxHours}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MaxHours: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}

      {isAddNew == 3 && (
        <div className="inline-block-d width-100 reuse-border p-all20">
          <>
            <div className="inline-block-d max-w-600">
              <div className="template-box">
                <div className="template-flex">
                  Size: {getPackingSizeName(addEditObject.PackingSizeID)}
                </div>
                <div className="template-flex">
                  {" "}
                  Resources: {getResourceText()}
                </div>
                <div className="template-flex">
                  Time:{" "}
                  {addEditObject.MinHours != addEditObject.MaxHours ? (
                    <>
                      {addEditObject.MinHours}-{addEditObject.MaxHours}
                    </>
                  ) : (
                    <>{addEditObject.MinHours}</>
                  )}
                  hrs
                </div>
              </div>
              <div className="material-boxes">
                <div className="material-left">
                  {materialsPriceTemplate[0] &&
                    materialsPriceTemplate[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        {(item.MNVMaterialsListPriceID == 1 ||
                          item.MNVMaterialsListPriceID == 3 ||
                          item.MNVMaterialsListPriceID == 4 ||
                          item.MNVMaterialsListPriceID == 5) && (
                          <div className="material-flex">
                            <span className="m-f1">{item.ListPriceName}</span>
                            <div className="m-f2">
                              <input
                                className="input-field"
                                type="text"
                                value={item.NumberOfUnit}
                                onChange={(e: any) =>
                                  updateValue(
                                    e.target.value,
                                    "NumberOfUnit",
                                    index
                                  )
                                }
                                onBlur={(e: any) =>
                                  MNVMaterialsPriceTemplateSaveCustom(
                                    e.target.value,
                                    item.MNVMaterialsPriceTemplateID
                                  )
                                }
                              />
                            </div>
                            <span className="m-f3">
                              £
                              {item.RentingAmount?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                            </span>
                            <span className="m-f4">
                              £
                              {item.BuyingAmount?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  {materialsPriceTemplate[1] && (
                    <div>
                      <div className="material-flex">
                        <span className="m-f1"></span>
                        <span className="m-f2"></span>
                        <span className="m-f3 bold-font txt-cen">Exc VAT</span>
                        <span className="m-f4 bold-font txt-cen">Inc VAT</span>
                      </div>
                      <div className="material-flex">
                        <span className="m-f1 bold-font">Total </span>
                        <span className="m-f2 bold-font bor-all">Renting </span>
                        <span className="m-f3 bor-all">
                          £
                          {materialsPriceTemplate[1][0].RentingAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                        <span className="m-f4 bold-font bor-all bor-right">
                          £
                          {materialsPriceTemplate[1][0].RentingAmountWithVAT?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                      </div>
                      <div className="material-flex">
                        <span className="m-f1"> </span>
                        <span className="m-f2 bold-font bor-all">Buying</span>
                        <span className="m-f3 bor-all">
                          £
                          {materialsPriceTemplate[1][0].BuyingAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                        <span className="m-f4 bold-font bor-all bor-right">
                          £
                          {materialsPriceTemplate[1][0].BuyingAmountWithVAT?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                      </div>
                      <div className="material-flex">
                        <span className="m-f1 bold-font c-red">
                          Difference{" "}
                        </span>
                        <span className="m-f2 bor-top h-30"></span>
                        <span className="m-f3 bor-all  bor-bottom c-red">
                          £
                          {materialsPriceTemplate[1][0].DifferenceInAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                        <span className="m-f4 bold-font bor-all bor-right  bor-bottom c-red">
                          £
                          {materialsPriceTemplate[1][0].DifferenceInAmountWithVAT?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="material-right">
                  {materialsPriceTemplate[0] &&
                    materialsPriceTemplate[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        {item.MNVMaterialsListPriceID != 1 &&
                          item.MNVMaterialsListPriceID != 3 &&
                          item.MNVMaterialsListPriceID != 4 &&
                          item.MNVMaterialsListPriceID != 5 && (
                            <div className="material-flex">
                              <span className="m-f1">
                                {item.ListPriceName}{" "}
                              </span>
                              <div className="m-f2">
                                <input
                                  className="input-field"
                                  type="text"
                                  value={item.NumberOfUnit}
                                  onChange={(e: any) =>
                                    updateValue(
                                      e.target.value,
                                      "NumberOfUnit",
                                      index
                                    )
                                  }
                                  onBlur={(e: any) =>
                                    MNVMaterialsPriceTemplateSaveCustom(
                                      e.target.value,
                                      item.MNVMaterialsPriceTemplateID
                                    )
                                  }
                                />
                              </div>
                              <span className="m-f3">
                                £
                                {item.RentingAmount?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}{" "}
                              </span>
                            </div>
                          )}
                      </React.Fragment>
                    ))}
                </div>
              </div>
              <div className="flex-daj btn-start mt--15">
                {/* <a
              className="btn-primary flex-daj"
              onClick={() => checkValidation()}
            >
            Save
             </a> */}
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Back to list
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default MaterialsTemplateType;
